<script>
  import { format } from 'svelte-i18n';

  import { Step } from '@client/components/steps';

  import { BizCardPusherService } from '@client/services/bizcard-pusher';

  import { Bizcards, Send, Users, WelcomeStatus } from './steps';

  export let assignments = [];
  export let initialBizcard = null;
  export let sent = false;

  let activeStep = initialBizcard ? 'users' : 'select';
  /** @type {string | null} */
  let bizcard = initialBizcard;
  let emailBody = $format('label.BIZCARD.ASSIGN.DEFAULT_EMAIL_BODY');
  let emailSubject = $format('label.BIZCARD.ASSIGN.DEFAULT_EMAIL_SUBJECT');
  let failures = 0;
  /** @type {import('@client/services/bizcard-pusher').PushResult[]} */
  let results = [];
  let selectedUsers = [];
  let sending = false;
  let successes = 0;
  let total = 1;

  const handleSend = async () => {
    sent = true;
    results = [];
    successes = 0;
    failures = 0;

    const emails = selectedUsers.map((u) => u.email || u.username).filter(Boolean);

    total = emails.length;
    sending = true;

    BizCardPusherService.pushBizcards(emails, emailSubject, emailBody)
      .node('{username}', (node) => {
        const success = node.status !== 'error';
        results = [...results, node];

        if (success) {
          successes += 1;
        } else {
          failures += 1;
        }
      })
      .done(() => {
        sending = false;
      });
  };

  $: current = results.length + 1;
</script>

{#if !sent}
  <div>
    <Step
      active={activeStep === 'select'}
      nextDisabled={!bizcard}
      title={$format('label.CHOOSE_BUSINESS_CARD')}
      summary={bizcard}
      onNext={() => (activeStep = 'users')}
      onStep={() => (activeStep = 'select')}
    >
      <Bizcards {assignments} bind:selected={bizcard} />
    </Step>

    <Step
      active={activeStep === 'users'}
      disabled={!bizcard}
      nextDisabled={!selectedUsers.length}
      title={$format('label.REVIEW_USERS')}
      summary={selectedUsers.length
        ? $format('label.BIZCARD.ASSIGN.USERS_COUNT', { values: { count: selectedUsers.length } })
        : undefined}
      onBack={() => (activeStep = 'select')}
      onNext={() => (activeStep = 'send')}
      onStep={() => (activeStep = 'users')}
    >
      <Users {bizcard} bind:selectedUsers />
    </Step>

    <Step
      active={activeStep === 'send'}
      disabled={!selectedUsers.length}
      title={$format('label.REVIEW')}
      onBack={() => (activeStep = 'users')}
      onStep={() => (activeStep = 'send')}
    >
      <Send onSend={handleSend} bind:subject={emailSubject} bind:body={emailBody} />
    </Step>
  </div>
{:else}
  <WelcomeStatus {current} {failures} {sending} {results} {successes} {total} />
{/if}
